import { redirect, useLoaderData, useParams, Link } from "react-router-dom";
import HttpRequest from "../../services/Request";
import TournamentComponent from "../../components/Tournament";
import Cookies from "js-cookie";
import BackButton from "../../components/BackButton";

const HseManagerTeams = () => {
  const { tournament, teams } = useLoaderData();
  const params = useParams();

  return (
    <div>
      <BackButton src={`/tournament/${params.id}`} />
      <div className="flex items-center">
        <TournamentComponent tournament={tournament} />
      </div>
      <div className="flex items-center mt-2">
        <div className="flex flex-wrap w-[97%] md:w-[90%] rounded-[15px] mx-auto mt-1 md:mt-0 md:mb-2 p-2 py-5">
          <div className="w-[80%] md:w-[27%] md:mt-5 text-center p-3 mx-auto shadow mt-3 bg-gray2 text-orange">
            <img
              src="/icons/icon-4.png"
              className="inline me-3 w-[25px] h-[25px]"
            />
            معرفی سرپرست
          </div>
        </div>
      </div>
      <div className="flex items-center mt-2">
        <div className="flex flex-wrap w-[97%] md:w-[90%] rounded-[15px] mx-auto mt-1 md:mt-0 md:mb-2 bg-white p-2 py-5">
          {teams.length === 0 ? (
            <div className="w-full text-center py-8 text-gray-500">
              هیچ تیمی به شما اختصاص داده نشده است
            </div>
          ) : (
            teams.map((team, index) => (
              <div
                key={team.id}
                className="w-[80%] md:w-[45%] mx-auto mb-4 p-4 shadow rounded-lg bg-gray2"
              >
                <div className="flex justify-between items-center mb-3">
                  <h3 className="text-[18px] text-orange font-bold">
                    {team.name}
                  </h3>
                  {team.supervisor ? (
                    <span className="text-[12px] text-green-600 bg-green-100 px-2 py-1 rounded">
                      سرپرست تعیین شده
                    </span>
                  ) : (
                    <span className="text-[12px] text-red-600 bg-red-100 px-2 py-1 rounded">
                      سرپرست تعیین نشده
                    </span>
                  )}
                </div>

                {team.supervisor ? (
                  <div className="text-[14px] text-gray-700 mb-3">
                    <p>
                      سرپرست: {team.supervisor.name} {team.supervisor.lastname}
                    </p>
                    <p>موبایل: {team.supervisor.mobile}</p>
                    <Link
                      to={`/tournament/${params.id}/hse-manager/teams/${team.id}/edit-supervisor`}
                      className="inline-block bg-orange text-white px-4 py-2 rounded text-[14px] font-bold mt-2"
                    >
                      ویرایش سرپرست
                    </Link>
                  </div>
                ) : (
                  <div className="text-[14px] text-gray-500 mb-3">
                    <p>سرپرست هنوز تعیین نشده است</p>
                  </div>
                )}

                {!team.supervisor && (
                  <Link
                    to={`/tournament/${params.id}/hse-manager/teams/${team.id}/assign-supervisor`}
                    className="inline-block bg-orange text-white px-4 py-2 rounded text-[14px] font-bold"
                  >
                    تعیین سرپرست
                  </Link>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default HseManagerTeams;

export async function HseManagerTeamsLoader({ params }) {
  let data = [];
  try {
    await HttpRequest(
      `${process.env.REACT_APP_DOMAIN}/tournament/${params.id}/hse-manager/teams`,
      (res) => {
        data = res.data;
      },
      "get",
      [],
      (err) => {
        let error = new Error();
        error.status = err.response.status;
        throw error;
      },
    );
  } catch (err) {
    if (err.status === 401) {
      Cookies.remove("access_token");
      return redirect("/login");
    }
  }
  return data;
}
